import { 
    ACTIVE_PAGE,
    NO_HEADER,
 } from './../Action-type/Index'


const initialState = {
    activePage: 'Home',
    noHeader: false
}

 
 function generals (state = initialState, action) {
     switch(action.type){
        case ACTIVE_PAGE: return {
            ...state,
            activePage: action.payload.activePage
        };
        case NO_HEADER: return {
            ...state,
            noHeader: true
        };
        default: return state;
     }
 }

 export default generals;